import { InstanceBatchLineMaterial } from "../instancing/lines/lineMaterials";
import { ConnectionLineTypes } from "flavr-common";
import { Color } from "flavr-math";
import { ConnectionRenderer } from "./connection.renderer";
const tmpColor = new Color();
export class BasicConnectionRenderer extends ConnectionRenderer {
    constructor(name, from, to, params) {
        super(name, from, to);
        this.params = params;
    }
    destroy() {
        super.destroy();
        this.instance && this.instance.destroy();
        this.instance = undefined;
    }
    setVisible(visible) {
        this.instance && this.instance.setVisible(visible);
    }
    update(params) {
        if (params.type === ConnectionLineTypes.Basic) {
            this.params = params;
            if (this.instance) {
                this.instance.setColor(tmpColor.setHex(this.params.lineColor));
                this.instance.setThickness(this.params.lineThickness);
                this.instance.setFuzzyness(0);
            }
            return true;
        }
        return false;
    }
    updateStartAndEndPoints(start, end) {
        if (!this.instance)
            this.instance = this.createInstance();
        this.instance.setStartPoint(start);
        this.instance.setEndPoint(end);
    }
    createInstance() {
        const batch = this.from.renderer.getLineBatch(this.from.modelUID, InstanceBatchLineMaterial.BASIC_LINE);
        const instance = batch.createInstance();
        instance.setColor(tmpColor.setHex(this.params.lineColor));
        instance.setThickness(this.params.lineThickness);
        instance.setFuzzyness(0);
        instance.setVisible(this.from.visible && this.to.visible);
        return instance;
    }
}
